import { useState, useCallback } from 'react';
import { Text, VStack } from '@chakra-ui/react';
import SearchAndFiltersSection from '@/components/section/SearchAndFiltersSection';
import Drawer, { DrawerHeader, DrawerTitle, DrawerBody } from '@/components/ui/Drawer';
import Button from '@/components/ui/Button';
import Pagination from '@/components/ui/Pagination';
import { useFrontlineOrganizationsQuery } from '@/entities/frontline/api';
import FrontlineSetupPage from './FrontlineSetupPage';

export default function FrontlineSetupDrawer({ organizationId, onSelect, onClose }: {
  organizationId?: string;
  onSelect: (id: string) => void;
  onClose: () => void;
}) {
  return <Drawer isOpen onClose={onClose} size="lg">
    <DrawerHeader><DrawerTitle>{organizationId ? 'Manage Frontline setup' : 'Set up an organization'}</DrawerTitle></DrawerHeader>
    <DrawerBody>
      {organizationId ? <FrontlineSetupPage key={organizationId} organizationId={organizationId} /> : <OrganizationPicker onSelect={onSelect} />}
    </DrawerBody>
  </Drawer>;
}

function OrganizationPicker({ onSelect }: { onSelect: (id: string) => void }) {
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const onSearchChange = useCallback((value: string) => { setSearch(value); setPage(1); }, []);
  const query = useFrontlineOrganizationsQuery({ search, page, scope: 'all' });
  return <VStack align="stretch" gap={4}>
    <Text>Choose an organization to configure Frontline.</Text>
    <SearchAndFiltersSection searchValue={search} searchPlaceholder="Search by organization name..." onSearchChange={onSearchChange} />
    {query.isError ? <Text role="alert">Could not load organizations. <Button variant="ghost" onClick={() => void query.refetch()}>Retry</Button></Text>
      : query.isFetching ? <Text role="status">Loading organizations…</Text>
      : query.currentData?.data.length ? query.currentData.data.map(org => <Button key={org.id} variant="outline" justifyContent="space-between" onClick={() => onSelect(org.id)}><Text truncate>{org.name}</Text><Text fontSize="sm">Select</Text></Button>)
      : <Text>No organizations found.</Text>}
    {query.currentData && <Pagination paginationInfo={query.currentData} onPageChange={setPage} showPageSizeSelector={false} isLoading={query.isFetching} />}
  </VStack>;
}
